<template>
    <div class="cf-item-wrapper">
        <ul class="cf-nav">
            <li v-for="item in items" :key="item.id">
                <NuxtLink :class="[item.url_without_domain == category.url_without_domain && 'active']" :to="item.url_without_domain"><span class="cf-nav-just-title">{{ item.title }}</span></NuxtLink>
            </li>
            <li v-if="category?.level > 1">
                <NuxtLink :to="category?.breadcrumbs ? Object.values(category.breadcrumbs).at(-2)?.url_without_domain : category.url_without_domain"><BaseCmsLabel code="show_all" /></NuxtLink>
            </li>
        </ul>
    </div>
</template>

<script setup>
    const props = defineProps(['items', 'category']);
</script>
